import { useResources } from 'datx-jsonapi-react';
import { useQuery } from '@tanstack/react-query';

import { queryProfilePlaylists } from '@/queries/profile-playlists';
import { sessionQueryOptions } from '@/queries/upgrade/sessions';
import { Flex, Skeleton } from '@chakra-ui/react';
import { DeletePlaylistModal } from '@/components/ui/features/lecture/BookmarkLectureModal/components/DeletePlaylistModal';
import { FC, useState } from 'react';
import { queryLecturePlaylists } from '@/queries/lecture-playlist';
import { PlaylistItem } from '@/components/ui/features/lecture/BookmarkLectureModal/components/PlaylistItem';
import { WatchlistItem } from '@/components/ui/features/lecture/BookmarkLectureModal/components/WatchlistItem';
import { WATCHLIST_NAME } from '@/components/ui/features/lecture/BookmarkLectureModal/constants';

export const PlaylistsList: FC<{ lectureId: string }> = ({ lectureId }) => {
  const { data: session } = useQuery(sessionQueryOptions());
  const main_profile = session?.main_profile;
  const [deletePlaylistId, setDeletePlaylistId] = useState(null);

  const { data: profilePlaylists } = useResources(queryProfilePlaylists(main_profile?.id));
  const { data: lecturePlaylists } = useResources(queryLecturePlaylists(main_profile?.id, { lecture_id: lectureId }));

  const excludedWatchlist = profilePlaylists?.filter((pp) => pp.name !== WATCHLIST_NAME);

  if (!lecturePlaylists) return <Skeleton />;

  return (
    <Flex h={{ base: '100%', lg: '300px' }} pr="2" overflowY="scroll" flexDirection="column">
      <WatchlistItem h="40px" mt={8} lectureId={lectureId} />
      {excludedWatchlist.map((pp) => (
        <PlaylistItem key={pp.id} lectureId={lectureId} playlist={pp} deletePlaylist={setDeletePlaylistId} />
      ))}
      <DeletePlaylistModal playlistId={deletePlaylistId} onClose={() => setDeletePlaylistId(null)} />
    </Flex>
  );
};
